module.exports = __webpack_public_path__ + "img/verve.18b0291f.svg";